import toIcon from '../toIcon';
import svg from './icon.svg'; // 6

const AppleIcon = toIcon(svg, { margin: '0 -.04em' });

export default AppleIcon;
